import { Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-bio-logo",
  standalone: true,
  imports: [MatIcon, SharedModule],
  templateUrl: "./bio-logo.component.html",
  styleUrl: "./bio-logo.component.scss",
})
export class BioLogoComponent {
  size = input<"small" | "normal">("normal");
}
